import {Authorization} from 'domain/usecases';

export function getAttendanceProtocol(authorization: Authorization): string {
	return authorization.nuProtocoloSolicitacao || authorization.nuProtocolo;
}

export function getInternalProtocol(authorization: Authorization): string {
	return authorization.protocolo || authorization.nuRegistro;
}
